/* © CNES */
/**
 * Layers to display on map.
 * @param children each layer to display.
 * @returns Element
 */
const Layers = ({ children }: { children: any }) => {
  return <div>{children}</div>;
};
export default Layers;
